export default {
	appName: 'Idicare',
	// apiURL: 'http://localhost:8080',
	// apiURL: 'https://app.idicare.com/api',
	apiURL: 'https://beta.idicare.com/api',
	stripePK: 'pk_test_65BVP6J1Qwl3eInDHgYzyodW',
	googleMapsKey: 'AIzaSyAbqenzl3ZKNJY6fOEy9CvBicWW_Ts9ltQ',
	googleMapsLibraries: ['places', 'drawing'],
	defaultLang: 'en-gb'
}



// WEBPACK FOOTER //
// ./src/settings/index.js